export function AdminFooter() {
  return (
    <footer className="border-t py-4">
      <p className="text-center text-xs text-muted-foreground">
        &copy; {new Date().getFullYear()} ODD. Admin Portal.
      </p>
    </footer>
  )
}
